export default [
    {
        "cardId": 1010001,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "0"
    },
    {
        "cardId": 1020001,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "0"
    },
    {
        "cardId": 1030001,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "0"
    },
    {
        "cardId": 1040001,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "0"
    },
    {
        "cardId": 1050001,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "0"
    },
    {
        "cardId": 1060001,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "0"
    },
    {
        "cardId": 1070001,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "0"
    },
    {
        "cardId": 1080001,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "0"
    },
    {
        "cardId": 1090001,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "0"
    },
    {
        "cardId": 1100001,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "0"
    },
    {
        "cardId": 1110001,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "0"
    },
    {
        "cardId": 1120001,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "0"
    },
    {
        "cardId": 1130001,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "0"
    },
    {
        "cardId": 1140001,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "0"
    },
    {
        "cardId": 1150001,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "0"
    },
    {
        "cardId": 1160001,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "0"
    },
    {
        "cardId": 2010002,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2020002,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2030002,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2040002,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2050002,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2060002,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2070002,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2080002,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2090002,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2100002,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2110002,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2120002,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2130002,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2140002,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2150002,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2160002,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【声優のタマゴ】"
    },
    {
        "cardId": 2010003,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2020003,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2030003,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2040003,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2050003,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2060003,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2070003,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2080003,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2090003,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2100003,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2110003,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2120003,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2130003,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2140003,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2150003,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 2160003,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【空を見上げて】"
    },
    {
        "cardId": 3010004,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【ステップ・バイ・ステップ】"
    },
    {
        "cardId": 3020004,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【カミズ・ホリデイ】"
    },
    {
        "cardId": 3030004,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【僕と猫】"
    },
    {
        "cardId": 3040004,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【チェイス！】"
    },
    {
        "cardId": 3050004,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【永久機関オルタネーター】"
    },
    {
        "cardId": 3060004,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【シスター・シスター】"
    },
    {
        "cardId": 3070004,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【ひとりでできるもん！】"
    },
    {
        "cardId": 3080004,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【楽しみの求道者】"
    },
    {
        "cardId": 3090004,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【フェアリー・オン・ステージ】"
    },
    {
        "cardId": 3100004,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【Don’t be a stranger.】"
    },
    {
        "cardId": 3110004,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【dig down メモリーズ】"
    },
    {
        "cardId": 3120004,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【幸運を抱きしめて】"
    },
    {
        "cardId": 3130004,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【賞味期限にご注意を】"
    },
    {
        "cardId": 3140004,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【聡里の宝物庫】"
    },
    {
        "cardId": 3150004,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【走れ凛音】"
    },
    {
        "cardId": 3160004,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【オブジェクト・アンディファインド】"
    },
    {
        "cardId": 4010005,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4020005,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4030005,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4040005,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4050005,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4060005,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4070005,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4080005,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4090005,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4100005,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4110005,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4120005,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4130005,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4140005,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4150005,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 4160005,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【Forever Friends】"
    },
    {
        "cardId": 3010006,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【クロスロード・サインポスト】"
    },
    {
        "cardId": 3020006,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【そっと背中を押して】"
    },
    {
        "cardId": 3030006,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【視線の奥に】"
    },
    {
        "cardId": 3040006,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【Let's go around】"
    },
    {
        "cardId": 3050006,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【唇よ、熱くキミを語れ！】"
    },
    {
        "cardId": 3060006,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【プリンセスは大忙し】"
    },
    {
        "cardId": 3070006,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【未来の主人公？】"
    },
    {
        "cardId": 3080006,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【ネオリアリズム！】"
    },
    {
        "cardId": 3090006,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【幸せをルバートで】"
    },
    {
        "cardId": 3100006,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【the shine leads...】"
    },
    {
        "cardId": 3110006,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【ハッピーハンティング】"
    },
    {
        "cardId": 3120006,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【天使は肉体労働がお好き】"
    },
    {
        "cardId": 3130006,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【客星のきざし】"
    },
    {
        "cardId": 3140006,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【獣の操者】"
    },
    {
        "cardId": 3150006,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【しあわせのかたち】"
    },
    {
        "cardId": 3160006,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【ダーク・ルーム】"
    },
    {
        "cardId": 4050007,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【三兵衛、秋の感謝フェア】"
    },
    {
        "cardId": 4090007,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【ゆっくり消える虹を見て】"
    },
    {
        "cardId": 3110007,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【古書ツナグ古都、photo】"
    },
    {
        "cardId": 4040007,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【フラワートレック】"
    },
    {
        "cardId": 3010007,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【秋晴れ乙女】"
    },
    {
        "cardId": 4020007,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【シタマチ・ファミリア】"
    },
    {
        "cardId": 4160007,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【ヴィジョン・キツネ】"
    },
    {
        "cardId": 3150007,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【エイジ・オブ・ディスカバリー】"
    },
    {
        "cardId": 4130007,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【Reach For The World!】"
    },
    {
        "cardId": 3140007,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【君、死にたもうことなかれ】"
    },
    {
        "cardId": 4130009,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【カストールの安息日】"
    },
    {
        "cardId": 4140008,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【勝利の栄光を君に】"
    },
    {
        "cardId": 3130008,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【黒祭ドミネーション】"
    },
    {
        "cardId": 4100007,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【in other words】"
    },
    {
        "cardId": 3120008,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【縁起色レイクフェア】"
    },
    {
        "cardId": 4080007,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【What a girl wants】"
    },
    {
        "cardId": 3060007,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【舞踏会へようこそ】"
    },
    {
        "cardId": 4070007,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【導きのロストラビット】"
    },
    {
        "cardId": 3050008,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【鋼のウィンターブレイカー】"
    },
    {
        "cardId": 4120009,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【パウダーシュガーの降る頃に】"
    },
    {
        "cardId": 3100008,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【Reunion. 街角にて】"
    },
    {
        "cardId": 4110008,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【ユメ・ウツツ・Unconscious】"
    },
    {
        "cardId": 3090008,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【Dreams will come true】"
    },
    {
        "cardId": 4040008,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【Never Knows Best】"
    },
    {
        "cardId": 4160008,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【Only two twin primes】"
    },
    {
        "cardId": 4030007,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【ひとりこのへやで】"
    },
    {
        "cardId": 3020008,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【フォーチュンランナー】"
    },
    {
        "cardId": 3010008,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【グロウアップ・デイズ】"
    },
    {
        "cardId": 4050009,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【疾走れ！自転の勇者ママチャリオン】"
    },
    {
        "cardId": 3070008,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【ワンデイ・スター】"
    },
    {
        "cardId": 4060008,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【小さな当たり前と大きな幸せ】"
    },
    {
        "cardId": 3080008,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【ルーキーアイスガール】"
    },
    {
        "cardId": 4060009,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【笑顔で空を灯して】"
    },
    {
        "cardId": 4090009,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【スイート・セレナーデ】"
    },
    {
        "cardId": 4130010,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【炎獄式ビターエンド】"
    },
    {
        "cardId": 4010009,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【束の間のロンググッドバイ】"
    },
    {
        "cardId": 3040009,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【クリアスノウ】"
    },
    {
        "cardId": 4010010,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【桜の花舞う教室で】"
    },
    {
        "cardId": 4070009,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【春風トラベリング】"
    },
    {
        "cardId": 4080009,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【ランチタイム・アップデート】"
    },
    {
        "cardId": 3050010,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【爆誕！TENDO-MkⅡ】"
    },
    {
        "cardId": 4150008,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【フィルムいっぱいの思い出を】"
    },
    {
        "cardId": 3160009,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【ウィスパリング・ワン】"
    },
    {
        "cardId": 4150009,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【極彩色で笑いたい】"
    },
    {
        "cardId": 3100009,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【Can you see what I see】"
    },
    {
        "cardId": 4110009,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【DAYS and the DAY】"
    },
    {
        "cardId": 4120010,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【タイムコールが聴こえる】"
    },
    {
        "cardId": 4040010,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【スタンドバイミー】"
    },
    {
        "cardId": 3010011,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【リトル・バイ・リトル】"
    },
    {
        "cardId": 4030008,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【わたしにできること】"
    },
    {
        "cardId": 3020009,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【シンケン・トライブ】"
    },
    {
        "cardId": 4060010,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【今日は明日の思い出】"
    },
    {
        "cardId": 3140009,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【掌のカラフル】"
    },
    {
        "cardId": 4090010,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【Secret Garden】"
    },
    {
        "cardId": 4090011,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【雲がちぎれる時を】"
    },
    {
        "cardId": 4020010,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【シロクロ・コミット】"
    },
    {
        "cardId": 3120011,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【君が選ばれた日に】"
    },
    {
        "cardId": 4080010,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【UP！】"
    },
    {
        "cardId": 3070010,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【コネクト】"
    },
    {
        "cardId": 4140010,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【ウェーニーウィーディーウィーキー】"
    },
    {
        "cardId": 3030009,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【かぜのまにまに】"
    },
    {
        "cardId": 4160010,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【リンケージ・マイナー】"
    },
    {
        "cardId": 4110010,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【孤独ノスヽメ】"
    },
    {
        "cardId": 3040011,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【ウィッシュムーン】"
    },
    {
        "cardId": 3130011,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【エリスちゃんは大忙し】"
    },
    {
        "cardId": 4030010,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【ぬれねこにひき】"
    },
    {
        "cardId": 4100010,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【back on top】"
    },
    {
        "cardId": 4070011,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【雨に唄えば】"
    },
    {
        "cardId": 3080011,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【リトルプレジデント】"
    },
    {
        "cardId": 4050011,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【僕らの声優力研究所】"
    },
    {
        "cardId": 3060011,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【この手に恵みを】"
    },
    {
        "cardId": 4130012,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【冷酷なる悪魔のエクスキューション】"
    },
    {
        "cardId": 4040012,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【女王に捧げる薬指】"
    },
    {
        "cardId": 4120012,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【オフショアの乙女】"
    },
    {
        "cardId": 4060012,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【部屋の中の晴々】"
    },
    {
        "cardId": 4080012,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【ユー・ガット・エール】"
    },
    {
        "cardId": 4140012,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【在りし日の詩】"
    },
    {
        "cardId": 4010012,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【エヴァーグリーン】"
    },
    {
        "cardId": 3030011,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【ことのはさらさら】"
    },
    {
        "cardId": 4150010,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【ビン詰めの花畑】"
    },
    {
        "cardId": 4160011,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【バレット・タイム】"
    },
    {
        "cardId": 4140011,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【雲の向こうは青空】"
    },
    {
        "cardId": 4050012,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【元気のオーラ・バトル】"
    },
    {
        "cardId": 4070012,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【ウォーターキャンディ】"
    },
    {
        "cardId": 4040013,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【fun! fun! fun!】"
    },
    {
        "cardId": 4150011,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【夏の日のイリュージョン】"
    },
    {
        "cardId": 4010013,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【廻る日の１ページ】"
    },
    {
        "cardId": 4060013,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【オーバー・ザ・シー】"
    },
    {
        "cardId": 3050013,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【てめぇら全員召し上がれ！】"
    },
    {
        "cardId": 4100011,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【End of twilight】"
    },
    {
        "cardId": 4090013,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【真夏の夜の夢】"
    },
    {
        "cardId": 4120013,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【私をビーチに連れてって】"
    },
    {
        "cardId": 4020011,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【ベイビー・クロケット】"
    },
    {
        "cardId": 4120014,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【エンドオブサマーを見送って】"
    },
    {
        "cardId": 4030012,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【なつかげすずし】"
    },
    {
        "cardId": 4110012,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【way of life, where to go?】"
    },
    {
        "cardId": 3070013,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【秋空のスイッチ】"
    },
    {
        "cardId": 4130013,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【誰ソ彼のオーダー】"
    },
    {
        "cardId": 4140013,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【ステラ・ハント】"
    },
    {
        "cardId": 4040014,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【way of life】"
    },
    {
        "cardId": 3020012,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【キャンパス・エッヂ】"
    },
    {
        "cardId": 3100012,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【penguin avenue】"
    },
    {
        "cardId": 4050014,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【天童重工進出ス！】"
    },
    {
        "cardId": 4160012,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【Red Alert】"
    },
    {
        "cardId": 4080014,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【harvest ＆ pup】"
    },
    {
        "cardId": 3150012,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【おためしマーケット】"
    },
    {
        "cardId": 4010014,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【ハーモニー・ダイナー】"
    },
    {
        "cardId": 3140014,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【薔薇と黙示録をあなたに】"
    },
    {
        "cardId": 4090014,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【opus 66】"
    },
    {
        "cardId": 9030013,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【みちへのいざない】"
    },
    {
        "cardId": 4020013,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【ゴールデンアワー】"
    },
    {
        "cardId": 9010016,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【SEE YOU EVERYDAY】"
    },
    {
        "cardId": 4110014,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【DELIGHT & DAYLIGHT】"
    },
    {
        "cardId": 3120015,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【せきららにダブルス】"
    },
    {
        "cardId": 4150013,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【ゆうやけ小路】"
    },
    {
        "cardId": 3160013,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【オー・ド・ヴィー】"
    },
    {
        "cardId": 4060014,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【ハッピー・キングダムズ】"
    },
    {
        "cardId": 3070014,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【スウィート・ワン】"
    },
    {
        "cardId": 4080015,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【パッシング・トーキョー】"
    },
    {
        "cardId": 4130014,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【星辰揃いし夜の囁き】"
    },
    {
        "cardId": 4030014,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【いただきのほし】"
    },
    {
        "cardId": 4110013,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【RING! RING! RING!】"
    },
    {
        "cardId": 9140015,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【木枯らし古書店】"
    },
    {
        "cardId": 4100013,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【above the promise】"
    },
    {
        "cardId": 3090015,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【ウインナワルツ】"
    },
    {
        "cardId": 4010015,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【AiRBLUE X'mas!】"
    },
    {
        "cardId": 4120016,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【帰れない？帰らない？】"
    },
    {
        "cardId": 9060015,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【プリンス・チャーミング】"
    },
    {
        "cardId": 4040016,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【わたしのアリーナ！】"
    },
    {
        "cardId": 4160014,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【PORTAL】"
    },
    {
        "cardId": 4140016,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【プルス・ウルトラ】"
    },
    {
        "cardId": 3080016,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【Terms of Fortune】"
    },
    {
        "cardId": 9110015,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【NITELITE】"
    },
    {
        "cardId": 4070016,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【KAZAHANA】"
    },
    {
        "cardId": 4150014,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【ぱーふぇくとわーるど】"
    },
    {
        "cardId": 3010017,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【夜風が香る】"
    },
    {
        "cardId": 3130015,
        "heroineId": 13,
        "heroine": "丸山利恵",
        "alias": "【超展望ネスト】"
    },
    {
        "cardId": 4060016,
        "heroineId": 6,
        "heroine": "赤川千紗",
        "alias": "【魔法をかけて】"
    },
    {
        "cardId": 4050016,
        "heroineId": 5,
        "heroine": "天童悠希",
        "alias": "【ままならない戦場】"
    },
    {
        "cardId": 4020014,
        "heroineId": 2,
        "heroine": "鷹取舞花",
        "alias": "【ライトマイファイア】"
    },
    {
        "cardId": 9040017,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【Target of Subject】"
    },
    {
        "cardId": 4080017,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【Feast and Family】"
    },
    {
        "cardId": 3030015,
        "heroineId": 3,
        "heroine": "鹿野志穂",
        "alias": "【はんにんはヤツ】"
    },
    {
        "cardId": 4090016,
        "heroineId": 9,
        "heroine": "夜峰美晴",
        "alias": "【何度も言わせて】"
    },
    {
        "cardId": 4160015,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【アクターズ・ギルド】"
    },
    {
        "cardId": 4010018,
        "heroineId": 1,
        "heroine": "六石陽菜",
        "alias": "【届け君へ】"
    },
    {
        "cardId": 4070017,
        "heroineId": 7,
        "heroine": "恵庭あいり",
        "alias": "【未来永遠のともだち】"
    },
    {
        "cardId": 4140017,
        "heroineId": 14,
        "heroine": "宇津木聡里",
        "alias": "【ゲルトルート】"
    },
    {
        "cardId": 3100014,
        "heroineId": 10,
        "heroine": "神室絢",
        "alias": "【Fancy A Brew?】"
    },
    {
        "cardId": 4120017,
        "heroineId": 12,
        "heroine": "日名倉莉子",
        "alias": "【青空バイクに恋してる】"
    },
    {
        "cardId": 9150015,
        "heroineId": 15,
        "heroine": "明神凛音",
        "alias": "【はなみ発見！】"
    },
    {
        "cardId": 4160016,
        "heroineId": 16,
        "heroine": "遠見鳴",
        "alias": "【Usual Cases】"
    },
    {
        "cardId": 4110016,
        "heroineId": 11,
        "heroine": "宮路まほろ",
        "alias": "【You saw my soul】"
    },
    {
        "cardId": 3080018,
        "heroineId": 8,
        "heroine": "九条柚葉",
        "alias": "【The Back-up Plan】"
    },
    {
        "cardId": 4040018,
        "heroineId": 4,
        "heroine": "月居ほのか",
        "alias": "【タイドアフター】"
    }
]